class FetchError extends Error {
  public readonly status: number;
  public readonly body: Record<string, any>;

  constructor(status: number, body: Record<string, any>) {
    super(body?.message ?? 'Failed to execute query');
    this.status = status;
    this.body = body;
  }
}

export default FetchError;
